export let ProductName = /*#__PURE__*/function (ProductName) {
  ProductName[ProductName["None"] = 0] = "None";
  ProductName[ProductName["CheckingAndDebit"] = 1] = "CheckingAndDebit";
  ProductName[ProductName["SquareCard"] = 2] = "SquareCard";
  return ProductName;
}({});